import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { LeagueWeek } from '../../../../models/LeagueWeek';
import { GolfEventField } from '../../../../models/golfeventfield';
import { NgIf, NgFor } from '@angular/common';
import { GolfEventFieldScoreViewModel } from '../../../../models/viewmodels/golfeventfieldscore';
import { SelectableObject } from '../../../../models/viewmodels/selectableobject';
import { PostScoreRequest } from '../../../../models/postScoreRequest';
import { GolfEventService } from '../../../../services/golf-event.service';
import { ApplicationService } from '../../../../services/application.service';

@Component({
  selector: 'app-post-individual-round',
  standalone: true,
  imports: [FormsModule, NgFor, NgIf],
  templateUrl: './post-individual-round.component.html',
  styleUrl: './post-individual-round.component.css'
})
export class PostIndividualRoundComponent implements OnChanges {

  constructor(private golfEventService:GolfEventService, private applicationService:ApplicationService) {}
  
  @Input() leagueWeek:LeagueWeek|null = null;
  @Input() loggedInPlayerId:number|null = null;
  @Input() paidPlayers:Array<GolfEventField> = [];

  @Output() scoresPosted = new EventEmitter<void>;

  showFieldList:boolean = false;
  playersToPost:Array<GolfEventFieldScoreViewModel> = [];
  selectablePlayers:Array<SelectableObject> = [];

  ngOnChanges(changes: SimpleChanges) {      
    if (changes['paidPlayers']  || changes['loggedInPlayerId']) {
      if(this.selectablePlayers.length === 0) {
        this.paidPlayers.forEach(p => { this.selectablePlayers.push({ isSelected: false, obj: p}) });
      }
      if(this.loggedInPlayerId)
        this.addPlayerToPostList(this.loggedInPlayerId);
    }
  }

  addPlayerToPostList(playerId:number) {
    if(this.playersToPost.filter(p => p.player.playerId === playerId).length > 0) return;
    let player = this.selectablePlayers.filter(p => p.obj.playerId.toString() === playerId.toString())[0];
    if(!player) return;
    player.isSelected = true;
    let viewModel:GolfEventFieldScoreViewModel = { score: null, player: player.obj };
    this.playersToPost.push(viewModel);
  }

  removePlayer(playerId:number) {
    const index = this.playersToPost.findIndex(p => p.player.playerId === playerId);
    if (index !== -1) {
      this.playersToPost.splice(index, 1);
    }

    let player = this.selectablePlayers.filter(p => p.obj.playerId.toString() === playerId.toString())[0];
    if(!player) return;
    player.isSelected = false;
  }

  resetPlayersToPost() {
    if(!this.loggedInPlayerId) return;

    this.selectablePlayers.forEach(p => { p.isSelected = false; });

    this.playersToPost = [];
    this.addPlayerToPostList(this.loggedInPlayerId);
  }

  async postScore(form:NgForm) {
    if(!this.leagueWeek) return;

    form.control.markAllAsTouched();

    if(form.invalid) {
      alert("Form is invalid");
      return;
      
    }

    let leagueWeekId = this.leagueWeek.id;
    let scoresToPost:Array<PostScoreRequest> = [];
    this.playersToPost.forEach(post => {
      scoresToPost.push({
        leagueWeekId: leagueWeekId,
        playerId: post.player.playerId,
        email: null,
        score: post.score ? post.score : 0,
        teamId: null
      });
    });

    let invalidScores = scoresToPost.filter(s => s.score <= 18).length > 0;

    if(invalidScores) {
      alert("One or more scores is too low and considered an invalid entry.");
      return;
    }

    this.applicationService.showGlobalSpinner();
    try {
      await this.golfEventService.postScores(scoresToPost);
      this.resetPlayersToPost();
      this.scoresPosted.emit();
    } finally {
      this.applicationService.hideGlobalSpinner();
    }
  }
}
